<template>
  <div @click.stop="onChange" :class="checked ? 'radio-wrp radio-wrp-active' : 'radio-wrp'" :style="{background: disable ? '#f2f2f2' : ''}">
    <p v-if="checked" class="radio"></p>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange () {
      if (this.disable) {
        return
      }
      this.$emit('change')
    }
  }
}
</script>

<style lang="less" scoped>
  .radio-wrp {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: 1px solid rgba(153,153,153,1);
    .radio {
      background: #2196F3;
      width: 50%;
      height: 50%;
      border-radius: 100%;
    }
  }
  .radio-wrp-active {
    border-color: #2196F3
  }
</style>
